import { SalesSummaryCardProps } from "./types";
import {
  HStack,
  Pressable,
  Text,
  useBreakpointValue,
  View
} from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { getIconAndColorByType } from "./utils";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import ContentLoader, { Rect } from "react-content-loader/native";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";

export const SalesSummaryCard = ({
  title,
  type,
  date,
  value,
  isLoading,
  totalTransactions,
  onPress
}: SalesSummaryCardProps) => {
  const { icon, color } = getIconAndColorByType(type);

  const { isWeb: isWebDevice } = useDeviceType();

  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });

  if (isLoading) {
    return (
      <View mr="$4" minWidth={isWebDevice && !isMobile ? "$1/2" : "$80"}>
        <ContentLoader>
          <Rect
            x="0"
            y="0"
            rx="8"
            ry="8"
            width={!isMobile ? 420 : 320}
            height="80"
          />
        </ContentLoader>
      </View>
    );
  }

  return (
    <Pressable
      flex={1}
      p="$3"
      bg="$backgroundLight50"
      borderWidth={1}
      borderColor="$backgroundLight200"
      borderRadius="$2xl"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWidth={isWebDevice && !isMobile ? "$1/2" : "$80"}
      height={"100%"}
      gap={16}
      mr="$4"
      onPress={onPress}
    >
      <HStack space="sm">
        <HStack flex={1} alignItems="center" gap="$1">
          <Icon name={icon} size={20} color={color} variant="regular" />
          <Text
            fontSize="$sm"
            color="$textLight800"
            fontWeight={600}
            fontFamily="Inter_600SemiBold"
            $web-fontFamily="Inter"
          >
            {title}
          </Text>
        </HStack>
        <Text
          fontSize="$xs"
          color="$textLight800"
          fontWeight={400}
          fontFamily="Inter_400Regular"
          $web-fontFamily="Inter"
        >
          {date}
        </Text>
      </HStack>
      <HStack alignItems="flex-end">
        <Text
          flex={1}
          fontSize="$xl"
          fontWeight={600}
          fontFamily="Inter_600SemiBold"
          $web-fontFamily="Inter"
          color="$textLight800"
        >
          {numberToBrl(value)}
        </Text>
        <Text
          fontSize="$sm"
          fontWeight={400}
          fontFamily="Inter_400Medium"
          $web-fontFamily="Inter"
          color="$textLight800"
        >
          {totalTransactions
            ? `${totalTransactions} transaç${totalTransactions > 1 ? "ões" : "ão"}`
            : "Nenhuma transação"}
        </Text>
      </HStack>
    </Pressable>
  );
};
